export const MuiTextField = {
  styleOverrides: {
    root: {
      "& .MuiInputLabel-shrink": {
        display: "none",
        "& + .MuiInputBase-root .MuiInputBase-input": {
          paddingTop: 0,
          paddingBottom: 0,
        },
      },
      ["input::-webkit-outer-spin-button" && "input::-webkit-inner-spin-button"]: {
        WebkitAppearance: "none",
        margin: 0,
      },
      input: {
        MozAppearance: "textfield",
      },
    },
  },
}
